/* Be Glowing Theme — extras.js : قبل/بعد · سكرينات الآراء · المفضلة · الشحن المجاني لايف · المشاركة */
(function () {
  'use strict';
  var T = window.theme || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var AR = ['٠','١','٢','٣','٤','٥','٦','٧','٨','٩'];
  function ar(x) { x = String(x); return (T.money && T.money.arabic) ? x.replace(/[0-9]/g, function (d) { return AR[+d]; }) : x; }
  function money(c) { return T.formatMoney ? T.formatMoney(c) : (c / 100).toFixed(0); }
  function toast(msg) {
    var el = $('[data-toast]'); if (!el) return;
    el.textContent = msg; el.classList.add('is-show');
    clearTimeout(toast.t); toast.t = setTimeout(function () { el.classList.remove('is-show'); }, 2200);
  }
  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null'); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- قبل / بعد ---------- */
  document.addEventListener('input', function (e) {
    var r = e.target.closest && e.target.closest('[data-ba-range]'); if (!r) return;
    r.closest('[data-ba]').style.setProperty('--pos', r.value + '%');
  });

  /* ---------- سكرينات الآراء: تابات + تكبير ---------- */
  var lbList = [], lbIdx = 0, lbBox = null;
  function lbShow() {
    var body = $('[data-rvs-lb-body]', lbBox), img = lbList[lbIdx] && $('img', lbList[lbIdx]);
    if (!body || !img) return;
    var big = img.currentSrc || img.src; body.innerHTML = '<img src="' + esc(big) + '" alt="' + esc(img.alt) + '">';
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var cat = t.closest('[data-rvs-cat]');
    if (cat) {
      var box = cat.closest('[data-rvs]'), v = cat.dataset.rvsCat;
      $$('[data-rvs-cat]', box).forEach(function (b) { b.classList.toggle('is-active', b === cat); });
      $$('[data-rvs-item]', box).forEach(function (it) { it.hidden = !(v === '*' || it.dataset.rvsItem === v); });
      return;
    }
    var op = t.closest('[data-rvs-open]');
    if (op) {
      var sec = op.closest('[data-rvs]'); lbBox = $('[data-rvs-lb]', sec);
      lbList = $$('[data-rvs-item]', sec).filter(function (x) { return !x.hidden && $('img', x); });
      lbIdx = lbList.indexOf(op.closest('[data-rvs-item]'));
      if (lbIdx < 0 || !lbBox || !lbBox.showModal) return;
      lbShow(); lbBox.showModal(); return;
    }
    var st = t.closest('[data-rvs-step]');
    if (st && lbList.length) { lbIdx = (lbIdx + (+st.dataset.rvsStep) + lbList.length) % lbList.length; lbShow(); return; }
    if (t.closest('[data-rvs-close]') || (t.matches && t.matches('[data-rvs-lb]'))) { var d = t.closest('[data-rvs-lb]'); if (d) d.close(); }
  });

  /* ---------- المفضلة ---------- */
  var WL_KEY = 'nabtah-wl';
  function wlGet() { var a = store(WL_KEY); return Array.isArray(a) ? a : []; }
  function wlSet(a) { store(WL_KEY, a); wlPaint(); document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: a } })); }
  function wlPaint() {
    var a = wlGet();
    $$('[data-wl-toggle]').forEach(function (b) {
      var on = a.indexOf(b.dataset.wlToggle) > -1;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-wl-count]').forEach(function (c) { c.textContent = ar(a.length); c.hidden = a.length === 0; });
  }
  T.wishlist = { get: wlGet, set: wlSet };
  if (!T.wl || T.wl.on !== false) {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wl-toggle]'); if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var h = b.dataset.wlToggle, a = wlGet(), i = a.indexOf(h);
      if (i > -1) { a.splice(i, 1); toast((T.wl && T.wl.removed) || 'اتشالت من المفضلة'); }
      else { a.unshift(h); toast((T.wl && T.wl.added) || 'اتضافت للمفضلة ♥'); b.classList.add('wl-pop'); setTimeout(function () { b.classList.remove('wl-pop'); }, 500); }
      wlSet(a.slice(0, 60));
      var page = $('[data-wl-page]'); if (page) renderWlPage(page);
    }, true);
  }

  var wlCache = {};
  function fetchProduct(h) {
    if (wlCache[h]) return Promise.resolve(wlCache[h]);
    return fetch((T.routes && T.routes.root || '/').replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; }).then(function (p) { wlCache[h] = p; return p; }).catch(function () { return null; });
  }
  function renderWlPage(page) {
    var grid = $('[data-wl-grid]', page), empty = $('[data-wl-empty]', page), bar = $('[data-wl-bar]', page);
    var a = wlGet();
    if (!a.length) { grid.innerHTML = ''; empty.hidden = false; bar.hidden = true; return; }
    empty.hidden = true;
    Promise.all(a.map(fetchProduct)).then(function (list) {
      list = list.filter(Boolean);
      var total = 0, ids = [];
      grid.innerHTML = list.map(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
        var img = p.featured_image || ''; if (/^(https?:)?\/\//.test(img)) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=500';
        var cmp = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : 0;
        if (v.available) { total += v.price; ids.push(v.id); }
        var pct = cmp ? Math.round((cmp - v.price) * 100 / cmp) : 0;
        return '<div class="wlc">' +
          '<a class="wlc__img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
          (pct ? '<em>-' + ar(pct) + '٪</em>' : '') + '</a>' +
          '<button type="button" class="wlc__x" data-wl-toggle="' + esc(p.handle) + '" aria-label="إزالة">✕</button>' +
          '<div class="wlc__b"><a class="wlc__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="wlc__p"><b>' + money(v.price) + '</b>' + (cmp ? '<s>' + money(cmp) + '</s>' : '') + '</div>' +
          '<button type="button" class="btn btn--dark btn--block btn--sm" data-add-variant="' + v.id + '" data-qty="1"' + (v.available ? '' : ' disabled') + '>' +
          esc(v.available ? page.dataset.btn : page.dataset.soldout) + '</button></div></div>';
      }).join('');
      wlPaint();
      bar.hidden = false;
      var sm = $('[data-wl-summary]', page);
      if (sm) sm.innerHTML = (sm.dataset.tpl || '').replace('[count]', '<b>' + ar(list.length) + '</b>').replace('[total]', '<b>' + money(total) + '</b>');
      var all = $('[data-wl-add-all]', page);
      if (all) { all.disabled = !ids.length; all.onclick = function () { if (T.addItems) T.addItems(ids.map(function (id) { return { id: id, quantity: 1 }; })); }; }
    });
  }


  /* ---------- اختبار الشعر ---------- */
  function hqInit(box) {
    if (box.dataset.ready) return; box.dataset.ready = '1';
    var steps = $$('[data-hq-step]', box), qs = steps.filter(function (x) { return /^\d+$/.test(x.dataset.hqStep); });
    var picks = [], key = 'nabtah-quiz-' + box.dataset.key;
    function go(name) {
      steps.forEach(function (st) { st.classList.toggle('is-active', st.dataset.hqStep === String(name)); });
      var top = box.getBoundingClientRect().top + window.scrollY - 90;
      if (window.scrollY > top + 40) window.scrollTo({ top: top, behavior: 'smooth' });
    }
    function scoreOf(list) {
      var sc = {}, order = [];
      list.forEach(function (hs) { (hs || '').split(',').forEach(function (h, i) { h = h.trim(); if (!h) return; if (!(h in sc)) { sc[h] = 0; order.push(h); } sc[h] += 1 + (i === 0 ? 0.25 : 0); }); });
      return order.sort(function (a, b) { return sc[b] - sc[a] || order.indexOf(a) - order.indexOf(b); });
    }
    function card(p, v) {
      var img = p.featured_image || ''; if (/^(https?:)?\/\//.test(img)) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=300';
      var cmp = v.compare_at_price > v.price ? v.compare_at_price : 0;
      return '<div class="hq__p"><a href="' + esc(p.url) + '" class="hq__pi">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
        '<div class="hq__pb"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a><span><b>' + money(v.price) + '</b>' + (cmp ? ' <s>' + money(cmp) + '</s>' : '') + '</span></div>' +
        '<button type="button" class="hq__add" data-add-variant="' + v.id + '" data-qty="1"' + (v.available ? '' : ' disabled') + '>' + esc(box.dataset.btn) + '</button></div>';
    }
    function show(ranked) {
      go('loading');
      var tag = box.dataset.bundleTag || 'bundle', n = +box.dataset.count || 3;
      Promise.all(ranked.slice(0, 14).map(fetchProduct)).then(function (ps) {
        ps = ps.filter(Boolean);
        var isB = function (p) { return (p.tags || []).indexOf(tag) > -1; };
        var singles = ps.filter(function (p) { return !isB(p); }).slice(0, n), bundle = ps.filter(isB)[0];
        var av = function (p) { return (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0]; };
        var total = 0, ids = [];
        $('[data-hq-list]', box).innerHTML = singles.map(function (p) { var v = av(p); if (v.available) { total += v.price; ids.push(v.id); } return card(p, v); }).join('');
        var sum = $('[data-hq-sum]', box); sum.hidden = ids.length < 2;
        $('[data-hq-total]', box).innerHTML = 'الإجمالي <b>' + money(total) + '</b>';
        $('[data-hq-add-all]', box).onclick = function () { if (T.addItems) T.addItems(ids.map(function (id) { return { id: id, quantity: 1 }; })); };
        var bw = $('[data-hq-bundle]', box);
        if (bundle) {
          var bv = av(bundle), save = bv.compare_at_price > bv.price ? bv.compare_at_price - bv.price : 0;
          $('[data-hq-bundle-card]', box).innerHTML = card(bundle, bv) + (save ? '<span class="hq__save">' + esc((box.dataset.saveTpl || '').replace('[save]', '')) + '<b>' + money(save) + '</b></span>' : '');
          bw.hidden = false;
        } else bw.hidden = true;
        setTimeout(function () { go('result'); }, 500);
      });
    }
    box.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-hq-start]')) { picks = []; go(1); return; }
      if (t.closest('[data-hq-last]')) { var last = store(key); if (last && last.length) show(scoreOf(last)); return; }
      if (t.closest('[data-hq-restart]')) { picks = []; go(1); return; }
      if (t.closest('[data-hq-back]')) { var cur = box.querySelector('.hq__q.is-active'); var i = cur ? +cur.dataset.hqStep : 1; picks = picks.slice(0, Math.max(0, i - 2)); go(Math.max(1, i - 1)); return; }
      var a = t.closest('[data-hq-answer]');
      if (a) {
        var q = a.closest('[data-hq-step]'), idx = +q.dataset.hqStep;
        $$('[data-hq-answer]', q).forEach(function (x) { x.classList.toggle('is-picked', x === a); });
        picks[idx - 1] = a.dataset.h; picks.length = idx;
        setTimeout(function () {
          if (idx < qs.length) go(idx + 1);
          else { store(key, picks); show(scoreOf(picks)); }
        }, 220);
      }
    });
    var lb = $('[data-hq-last]', box); if (lb) lb.hidden = !(store(key) || []).length;
  }

  /* ---------- الشحن المجاني (لايف) ---------- */
  function paintFs(total) {
    $$('[data-fs]').forEach(function (el) {
      var goal = +el.dataset.goal || 0; if (!goal) return;
      var rem = goal - total, msg;
      var b = function (c) { return '<b>' + money(c) + '</b>'; };
      if (total <= 0) msg = (el.dataset.te || '').replace('[goal]', b(goal)).replace('[remaining]', b(goal));
      else if (rem > 0) msg = (el.dataset.tp || '').replace('[remaining]', b(rem)).replace('[goal]', b(goal));
      else msg = (el.dataset.td || '').replace('[goal]', b(goal));
      var m = $('[data-fs-msg]', el); if (m) m.innerHTML = msg;
      var f = $('[data-fs-fill]', el); if (f) f.style.width = Math.min(100, Math.round(total * 100 / goal)) + '%';
      el.classList.toggle('is-done', rem <= 0 && total > 0);
    });
  }
  var fsBusy = false;
  function refreshFs() {
    if (fsBusy || !$('[data-fs]')) return; fsBusy = true;
    fetch((T.routes && T.routes.root || '/').replace(/\/$/, '') + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { paintFs(c.total_price); })
      .catch(function () {}).then(function () { fsBusy = false; });
  }
  document.addEventListener('cart:updated', function () { setTimeout(refreshFs, 60); });


  /* ---------- تكفي قد إيه (حسب الفارينت) ---------- */
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant; if (!v) return;
    $$('[data-dur]').forEach(function (el) {
      var map = {}; try { map = JSON.parse(el.dataset.dur); } catch (x) {}
      var t = map[v.title] || map[(v.options || [])[0]] || '';
      var tx = $('[data-dur-text]', el); if (tx) tx.textContent = t; el.hidden = !t;
    });
  });


  /* ---------- تشغيل الفيديوهات تلقائي لما تظهر ---------- */
  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target, card = v.closest('[data-video-card]');
      if (e.isIntersecting) { v.muted = true; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); if (card) card.classList.add('is-playing'); }
      else { v.pause(); if (card) card.classList.remove('is-playing'); }
    });
  }, { threshold: .45 }) : null;
  function watchVideos() { if (vio) $$('video[data-autoplay]:not([data-watched])').forEach(function (v) { v.dataset.watched = '1'; vio.observe(v); }); }


  /* ---------- دواير الأقسام: تلميح حركة مرة واحدة ---------- */
  function stcHint() {
    $$('[data-stc-hint="hint"]:not([data-hinted])').forEach(function (el) {
      el.dataset.hinted = '1';
      if (el.scrollWidth <= el.clientWidth + 4) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var run = function () {
        var rtl = getComputedStyle(el).direction === 'rtl', d = rtl ? -1 : 1;
        el.scrollTo({ left: el.scrollLeft + d * 90, behavior: 'smooth' });
        setTimeout(function () { el.scrollTo({ left: rtl ? 0 : 0, behavior: 'smooth' }); }, 700);
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); setTimeout(run, 600); } }, { threshold: .6 });
        io.observe(el);
      } else setTimeout(run, 1200);
      var stop = function () { el.dataset.hinted = 'done'; };
      el.addEventListener('touchstart', stop, { passive: true, once: true });
    });
  }


  /* ---------- سكرول ناعم للينكات الداخلية (اقرئي التفاصيل / ارجعي للعرض) ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#pdp-"]'); if (!a) return;
    var t = document.querySelector(a.getAttribute('href')); if (!t) return;
    e.preventDefault();
    var hdr = document.querySelector('[data-header].is-sticky'); var off = (hdr ? hdr.offsetHeight : 0) + 16;
    window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - off, behavior: 'smooth' });
    if (t.id === 'pdp-buy') { t.classList.add('pp--flash'); setTimeout(function () { t.classList.remove('pp--flash'); }, 1400); }
  });

  /* ---------- مشاركة ---------- */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-copy-link]');
    if (c) {
      var u = location.href.split('#')[0];
      var done = function () { toast(c.dataset.done || T.copied || 'اتنسخ ✓'); };
      if (navigator.clipboard) navigator.clipboard.writeText(u).then(done, done); else done();
      return;
    }
    var n = e.target.closest('[data-native-share]');
    if (n && navigator.share) navigator.share({ title: n.dataset.title || document.title, url: location.href.split('#')[0] }).catch(function () {});
  });

  function init() {
    wlPaint();
    $$('[data-hq]').forEach(hqInit);
    watchVideos();
    stcHint();
    var page = $('[data-wl-page]'); if (page) renderWlPage(page);
    if (navigator.share) $$('[data-native-share]').forEach(function (b) { b.hidden = false; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  /* لما الكارت تتعمل من جديد (كويك فيو / بحث) */
  new MutationObserver(function (ms) { for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { clearTimeout(init.t); init.t = setTimeout(wlPaint, 80); return; } })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* تذكير إعادة الطلب: بيتبعت كفورم customer منفصل (مش جوه فورم المنتج) */
(function(){
  document.querySelectorAll('[data-remind]').forEach(function(w){
    if (/customer_posted=true/.test(location.search)) { var ok=w.querySelector('[data-remind-ok]'); if(ok){ ok.hidden=false; w.querySelectorAll('input,button').forEach(function(e){ e.hidden=true; }); } }
    var inp=w.querySelector('[data-remind-email]'), btn=w.querySelector('[data-remind-send]');
    if(!inp||!btn) return;
    function send(){
      var v=(inp.value||'').trim();
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)){ inp.classList.add('is-err'); inp.focus(); return; }
      var f=document.createElement('form'); f.method='post'; f.action='/contact#remind'; f.style.display='none';
      [['form_type','customer'],['utf8','✓'],['contact[email]',v],['contact[tags]',w.getAttribute('data-tags')]].forEach(function(p){ var i=document.createElement('input'); i.type='hidden'; i.name=p[0]; i.value=p[1]; f.appendChild(i); });
      document.body.appendChild(f); f.submit();
    }
    btn.addEventListener('click',send);
    inp.addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); send(); } });
    inp.addEventListener('input',function(){ inp.classList.remove('is-err'); });
  });
})();

/* ===== اطلبي على واتساب + بلغيني لما يرجع ===== */
(function(){
  document.addEventListener('variant:change', function(e){
    var v = e.detail && e.detail.variant; if (!v) return;
    document.querySelectorAll('[data-wa-order]').forEach(function(a){ a.setAttribute('data-variant', v.title && v.title !== 'Default Title' ? v.title : ''); });
    document.querySelectorAll('[data-restock]').forEach(function(r){ r.hidden = !!v.available; });
  });
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('[data-wa-order]'); if (!a) return;
    var root = a.closest('[data-product-info]') || document;
    var qEl = root.querySelector('[data-form-qty]') || document.querySelector('[data-form-qty]');
    var pEl = root.querySelector('[data-pack-property]') || document.querySelector('[data-pack-property]');
    var msg = (a.getAttribute('data-tpl') || '[product]')
      .replace('[product]', a.getAttribute('data-title') || '')
      .replace('[variant]', a.getAttribute('data-variant') ? '(' + a.getAttribute('data-variant') + ')' : '')
      .replace('[pack]', pEl && pEl.value ? pEl.value : '')
      .replace('[qty]', qEl && qEl.value ? qEl.value : '1')
      .replace('[url]', a.getAttribute('data-url') || location.href)
      .replace(/\n\s*—\s*/g, '\n').replace(/[ \t]+\n/g, '\n').replace(/\n{2,}/g, '\n');
    a.href = 'https://wa.me/' + a.getAttribute('data-num') + '?text=' + encodeURIComponent(msg.trim());
  }, true);
})();

/* ===== جاليري صفحة المنتج: سحب بالصباع + نقط + تكبير ===== */
(function(){
  var AR = '٠١٢٣٤٥٦٧٨٩';
  function ar(n){ return String(n).replace(/\d/g, function(d){ return AR[d]; }); }
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var main = g.querySelector('.pdp__main'); if (!main || main.dataset.swipe) return; main.dataset.swipe = '1';
    var slides = Array.prototype.slice.call(main.querySelectorAll('[data-slide]'));
    if (!slides.length) return;
    function cur(){ for (var i = 0; i < slides.length; i++) if (slides[i].classList.contains('is-active')) return i; return 0; }
    function go(i){
      i = (i + slides.length) % slides.length;
      slides.forEach(function(s, k){ s.classList.toggle('is-active', k === i); });
      g.querySelectorAll('[data-thumb]').forEach(function(t, k){ t.classList.toggle('is-active', k === i); });
      var sn = g.querySelector('[data-slide-num]'); if (sn) sn.textContent = ar(i + 1);
      sync();
    }
    var dots;
    if (slides.length > 1) {
      dots = document.createElement('div'); dots.className = 'pdp__dots';
      slides.forEach(function(_, k){ var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'صورة ' + ar(k + 1)); b.addEventListener('click', function(ev){ ev.stopPropagation(); go(k); }); dots.appendChild(b); });
      main.appendChild(dots);
      ['prev', 'next'].forEach(function(dir){
        var b = document.createElement('button'); b.type = 'button'; b.className = 'pdp__arr pdp__arr--' + dir; b.setAttribute('aria-label', dir === 'next' ? 'التالي' : 'السابق');
        b.innerHTML = dir === 'next' ? '&#8249;' : '&#8250;';
        b.addEventListener('click', function(ev){ ev.stopPropagation(); go(cur() + (dir === 'next' ? 1 : -1)); });
        main.appendChild(b);
      });
    }
    function sync(){ if (!dots) return; var c = cur(); Array.prototype.forEach.call(dots.children, function(d, k){ d.classList.toggle('is-active', k === c); }); }
    new MutationObserver(sync).observe(slides[0].parentNode, { subtree: true, attributes: true, attributeFilter: ['class'] });
    sync();
    var rtl = (document.documentElement.dir || 'rtl') === 'rtl', x0 = null, y0 = 0, moved = false;
    main.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; moved = false; }, { passive: true });
    main.addEventListener('touchmove', function(e){ if (x0 !== null && Math.abs(e.touches[0].clientX - x0) > 10) moved = true; }, { passive: true });
    main.addEventListener('touchend', function(e){
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2 && slides.length > 1) { go(cur() + ((dx > 0) === rtl ? 1 : -1)); }
    });
    /* تكبير */
    main.addEventListener('click', function(e){
      if (moved || e.target.closest('button,a,video,iframe')) return;
      var imgs = slides.map(function(s){ var im = s.querySelector('img'); return im ? (im.currentSrc || im.src) : null; });
      if (!imgs[cur()]) return;
      var ov = document.createElement('div'); ov.className = 'gzoom'; ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-label', 'تكبير الصور');
      var tr = document.createElement('div'); tr.className = 'gzoom__track';
      imgs.forEach(function(u){ if (!u) return; var f = document.createElement('div'); f.className = 'gzoom__f'; var im = new Image(); im.src = u.replace(/width=\d+/, 'width=2000'); im.alt = ''; f.appendChild(im); tr.appendChild(f); });
      var x = document.createElement('button'); x.type = 'button'; x.className = 'gzoom__x'; x.setAttribute('aria-label', 'إغلاق'); x.textContent = '✕';
      ov.appendChild(tr); ov.appendChild(x); document.body.appendChild(ov); document.documentElement.style.overflow = 'hidden';
      var idx = imgs.slice(0, cur()).filter(Boolean).length;
      requestAnimationFrame(function(){ var f = tr.children[idx]; if (f) tr.scrollLeft = f.offsetLeft - tr.offsetLeft; ov.classList.add('is-open'); });
      function close(){ ov.remove(); document.documentElement.style.overflow = ''; document.removeEventListener('keydown', esc); }
      function esc(ev){ if (ev.key === 'Escape') close(); }
      x.addEventListener('click', close); document.addEventListener('keydown', esc);
      tr.addEventListener('click', function(ev){ var im = ev.target.closest('img'); if (im) im.parentNode.classList.toggle('is-z'); else close(); });
    });
    main.classList.add('has-zoom');
  });
})();

/* ===== أزرار الحجم على كارت المنتج ===== */
document.addEventListener('click', function(e){
  var b = e.target.closest && e.target.closest('[data-sz-id]'); if (!b) return;
  e.preventDefault(); e.stopPropagation();
  var card = b.closest('.pcard'); if (!card) return;
  card.querySelectorAll('[data-sz-id]').forEach(function(x){ var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  var add = card.querySelector('.pcard__foot [data-add-variant]'); if (add) add.setAttribute('data-add-variant', b.getAttribute('data-sz-id'));
  var pr = card.querySelector('.pcard__price');
  if (pr) {
    var bEl = pr.querySelector('b'), sEl = pr.querySelector('s'), cmp = b.getAttribute('data-sz-cmp');
    var from = pr.querySelector('.pcard__from'); if (from) from.remove();
    if (bEl) bEl.textContent = b.getAttribute('data-sz-price');
    if (cmp) { if (!sEl) { sEl = document.createElement('s'); bEl.after(sEl); } sEl.textContent = cmp; sEl.hidden = false; } else if (sEl) sEl.hidden = true;
  }
}, true);
